import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaintBucketDrop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPaintBucketDrop"><Path d="M21.5 19.5C21.5 20.6046 20.7165 21.5 19.75 21.5C18.7835 21.5 18 20.6046 18 19.5C18 18 19.75 16.5 19.75 16.5C19.75 16.5 21.5 18 21.5 19.5Z" stroke="currentColor"/><Path d="M10.5096 20.8782L20.8733 12.953L10.6203 2.69995L2.69508 13.0637C1.78171 14.2581 1.89362 15.9441 2.95683 17.0073L6.56594 20.6164C7.62915 21.6796 9.3152 21.7916 10.5096 20.8782Z" stroke="currentColor"/><Path d="M12.5 11.5L2 6" stroke="currentColor"/></CentralIconBase>;
});

export default IconPaintBucketDrop;
